import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store.js";
import Axios from "axios";
import BootstrapVue from "bootstrap-vue";

Vue.use(BootstrapVue);

Vue.prototype.$http = Axios;

const token = localStorage.getItem("user-token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
